import { UploadImageService } from './upload-image-service';

export class UploadImageServiceFake implements UploadImageService {
  async upload() {
    await new Promise((r) => setTimeout(r, 1000));
    return 'https://lipsum.app/random/100x100';
  }
}
